<template>
  <div class="theme">
    <el-tooltip :content="theme" effect="dark" placement="bottom">
      <div class="btn-icon" @click="toTask">
        <svg-icon :style="{color:'#606266'}" icon-class="icon-header-task" style="font-size:20px!important;" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    theme() {
      return this._i18n.tc('navbar.task')
    }
  },
  methods: {
    toTask() {
      this.$router.push({name: 'processed'})
    }
  }
}
</script>
<style lang="scss">
</style>

